import { BUTTON_VARIANT, extendTheme } from '@manulife/mux';

export const OTIP_BLUE = '#1A4587';
export const OTIP_DARK_BLUE = '#09244E';
export const OTIP_BRIGHT_BLUE = '#1356BA';
export const OTIP_GREY_BLUE = '#B5C2D7';
export const OTIP_SKY_BLUE = '#D2EDFF';
export const OTIP_LIGHT_BLUE = '#F2FAFF';
export const OTIP_ORBIT_ORANGE = '#FCB34C';
export const OTIP_ACCENT_YELLOW = '#FFE49C';
export const OTIP_ACTION_GREEN = '#044E49';
export const OTIP_ACTION_LIGHT_GREEN = '#066B64';
export const OTIP_LIGHT_GREEN = '#A7F3C5';

export const OTIP_THEME = extendTheme({
    name: 'otipTheme',
    colorPalette: {
        primaryColors: {
            // Link colour
            main: {
                shade_dark_2: OTIP_ACTION_GREEN,
                shade_default: OTIP_ACTION_LIGHT_GREEN,
                shade_link: OTIP_ACTION_GREEN,
            },
        },
        neutralColors: {
            dark: {
                shade_light_2: OTIP_BLUE,
                shade_default: OTIP_DARK_BLUE,
            },
        },
        // Button hover/active colours
        accentColor: {
            shade_default: OTIP_BLUE,
            shade_dark_1: OTIP_BLUE,
            shade_dark_2: OTIP_DARK_BLUE,
            shade_dark_3: OTIP_DARK_BLUE,
        },
    },
    sideNav: {
        mainNav: {
            backgroundColor: OTIP_BLUE,
        },
        mobile: {
            backgroundColor: OTIP_DARK_BLUE,
            item: {
                backgroundColor: OTIP_BLUE,
            },
        },
    },
    utilityHeader: {
        main: {
            backgroundColor: OTIP_BLUE,
        },
        sub: {
            backgroundColor: OTIP_BLUE,
        },
    },
    button: {
        variant: {
            [BUTTON_VARIANT.PRIMARY]: {
                bg: OTIP_ORBIT_ORANGE,
                border: OTIP_ORBIT_ORANGE,
                color: OTIP_DARK_BLUE,
            },
        },
    },
});
